import styled from '@emotion/styled';
import { css } from '@emotion/react';

import theme from 'styles/theme';

export type InfoBoxSize = 'sm' | 'md';

type StyledProps = {
  $size: InfoBoxSize;
  $color?: string;
  $backgroundColor?: string;
  $borderColor?: string;
};

const sizeStyles: Record<InfoBoxSize, ReturnType<typeof css>> = {
  sm: css`
    padding: 8px 12px;
    font-size: 12px;
    border-radius: 6px;
  `,
  md: css`
    padding: 10px 16px;
    font-size: 14px;
    border-radius: 8px;
  `,
};

export const StyledInfoBox = styled('div', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<StyledProps>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  max-width: 100%;
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  line-height: 1.4;
  color: ${({ $color }) => $color || theme.colors.primaryText};
  background: ${({ $backgroundColor }) => $backgroundColor || '#F5F5F5'};
  border: 1px solid ${({ $borderColor }) => $borderColor || '#ECECEC'};

  ${({ $size }) => sizeStyles[$size]}
`;

export const IconSlot = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  line-height: 0;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const Content = styled.div`
  min-width: 0;
`;

export const Highlight = styled.strong`
  color: ${theme.colors.blue};
  font-weight: 600;
`;
